import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';

interface PrequalificationStatusBadgeProps {
  status: string;
  expiryDate?: string | null;
}

export function PrequalificationStatusBadge({ status, expiryDate }: PrequalificationStatusBadgeProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'approved':
        return {
          variant: 'default' as const,
          className: 'bg-green-500 hover:bg-green-600',
          label: '✓ Approved',
        };
      case 'pending_review':
        return {
          variant: 'secondary' as const,
          className: 'bg-orange-500 hover:bg-orange-600 text-white',
          label: '⏱ Pending Review',
        };
      case 'in_progress':
        return {
          variant: 'secondary' as const,
          className: 'bg-blue-500 hover:bg-blue-600 text-white',
          label: 'In Progress',
        };
      case 'rejected':
        return {
          variant: 'destructive' as const,
          className: '',
          label: '❌ Rejected',
        };
      case 'expired':
        return {
          variant: 'destructive' as const,
          className: 'bg-gray-500 hover:bg-gray-600',
          label: '⚠️ Expired',
        };
      default:
        return {
          variant: 'outline' as const,
          className: '',
          label: 'Not Started',
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className="flex flex-col gap-1">
      <Badge variant={config.variant} className={config.className}>
        {config.label}
      </Badge>
      {status === 'approved' && expiryDate && (
        <span className="text-xs text-muted-foreground">
          Expires: {format(new Date(expiryDate), 'MM/dd/yyyy')}
        </span>
      )}
    </div>
  );
}